import { useLayoutEffect } from 'react';

/**
 * Put every document scroller back at the top before the next paint.
 *
 * Product pages scroll the window. Footer tabs (Apps, Chat, Cases) scroll
 * `.app-main-content-layout` instead, because the root container is
 * overflow:hidden. A view swap on the same route never hits the router's
 * scroll reset, so callers run this when that swap replaces a long page.
 */
export function scrollDocumentToTop() {
  if (typeof document === 'undefined') return;

  document.querySelectorAll('.app-main-content-layout').forEach((el) => {
    el.scrollTop = 0;
  });

  const root = document.scrollingElement || document.documentElement;
  const previousBehavior = root ? root.style.scrollBehavior : '';
  const previousBodyBehavior = document.body ? document.body.style.scrollBehavior : '';
  if (root) root.style.scrollBehavior = 'auto';
  if (document.body) document.body.style.scrollBehavior = 'auto';
  if (root) root.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
  // jsdom's scrollTo only reports "Not implemented". Real browsers need it
  // so a smooth scroll already in flight cannot finish away from the top.
  if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
    const source = Function.prototype.toString.call(window.scrollTo);
    if (!source.includes('notImplemented')) window.scrollTo(0, 0);
  }
  if (root) root.style.scrollBehavior = previousBehavior;
  if (document.body) document.body.style.scrollBehavior = previousBodyBehavior;
}

/** Reset scroll whenever `key` changes, including the first paint. */
export function useScrollDocumentToTop(key) {
  useLayoutEffect(() => {
    scrollDocumentToTop();
  }, [key]);
}
